import { useState, type MouseEvent } from 'react'

/**
 * Open state for a saas-ui `Tooltip` that must also open on click or tap.
 *
 * Radix closes a tooltip on pointerdown, so an uncontrolled one never opens
 * from a click — and touch has no hover. Spread `open`/`onOpenChange` on the
 * `Tooltip` (hover, focus and Escape still drive it) and put `openOnClick` on
 * the trigger. The click stops propagating, so a trigger inside a sort button
 * or a clickable row does not also activate it.
 */
export function useClickableTooltip() {
  const [open, setOpen] = useState(false)
  return {
    open,
    onOpenChange: setOpen,
    openOnClick: (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      setOpen(true)
    },
  }
}
